import module from '../module';
import Constants from '../../../utils/CommonConstants';

export class UserProfileService {
    static $inject = ['$http', '$rootScope', 'cartonomyConfig', 'Session', 'LocalForageService'];

    constructor(httpService, rootScopeService, cartonomyConfig, sessionService, localForageService) {

        this.baseUrl = cartonomyConfig.ApiV2 + 'user';
        this.emailUrl = this.baseUrl + '/email';
        this.addressUrl = this.baseUrl + '/address';
        this._httpService = httpService;
        this.cartonomyConfig = cartonomyConfig;
        this._sessionService = sessionService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this._addresses = null;

        rootScopeService.$on(Constants.RootEvents.CART_CHANGED, () => {
            this.resetUser();
        });
    }

    saveProfile(profile) {

        return this._httpService.post(this.cartonomyConfig.ApiV2 + 'user/profile', profile).then((response) => {
            this._sessionService.setCachedUser(null);
            this._addresses = null;
            this.getUser(false);
            return response.data;
        });
    }

    resetUser() {
        this._addresses = null;
        this._sessionService.setCachedUser(null);
    }

    async getUser(getFromCache = true) {
        let cachedUser = this._sessionService.getCachedUser();

        if (getFromCache && cachedUser) {
            return cachedUser;
        }

        cachedUser = await this._httpService.get(this.baseUrl)
            .then(async (response) => {
                await this._localForageService.store(Constants.SessionStorage.USER_DATA, JSON.stringify(response.data));
                return response.data;
            });

        this._sessionService.setCachedUser(cachedUser);
        this._addresses = null;

        return cachedUser;
    }

    getUserEmails() {
        return this.getUser().then((user) => user.userEmails);
    }

    deleteEmail(email) {
        return this._httpService.delete(this.emailUrl + "/" + email.id).then(() => {
            this._sessionService.setCachedUser(null);
        });
    }

    updateEmail(email) {
        return this._httpService.patch(this.emailUrl, email).then((response) => {
            this._sessionService.setCachedUser(null);
            return response.data;
        });
    }

    createEmail(email) {
        return this._httpService.post(this.emailUrl, email).then((response) => {
            this._sessionService.setCachedUser(null);
            return response.data;
        });
    }

    getUserAddresses() {
        if (this._addresses) {
            return this._addresses;
        }
        this._addresses = this._httpService.get(this.addressUrl).then((response) => response.data);
        return this._addresses;
    }

    updateAddress(address) {
        return this._httpService.patch(this.addressUrl, address).then((response) => {
            this._addresses = null;
            this._sessionService.setCachedUser(null);
            return response.data;
        });
    }

    createAddress(address) {
        return this._httpService.post(this.addressUrl, address).then((response) => {
            this._addresses = null;
            this._sessionService.setCachedUser(null);
            return response.data;
        });
    }

    deleteAddress(id) {
        return this._httpService.delete(this.addressUrl + '/' + id).then(() => {
            this._addresses = null;
            this._sessionService.setCachedUser(null);
        });
    }

    updateOpenIdAvatar(providerId) {
        return this._httpService.get(this.baseUrl + '/avatar/oauth/' + providerId);
    }

    getUserAvatar(userEmail) {
        return this._httpService.get(`${this.baseUrl}/avatar/byemail?email=${userEmail}`);
    }

    uploadAvatar(file) {
        let config = {
            headers: {
                'Content-Type': undefined
            }
        };
        let formData = new window.FormData();
        formData.append('file', file);
        return this._httpService.post(`${this.cartonomyConfig.ApiV1}avatar/upload/jpg`,formData,config);
    }

}

module.service('UserProfile', UserProfileService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/UserProfileService.js